import type { FC } from "react"

import type { InventoryByProductWarehouse } from "@/graphql/codegen/graphql"
import { formatWarehouseLabel } from "@/utils/warehouse"

interface ProductInventoryWarehouseCellProps {
  inventories: InventoryByProductWarehouse[]
}

export const ProductInventoryWarehouseCell: FC<ProductInventoryWarehouseCellProps> = ({ inventories }) => {
  if (!inventories.length) return null

  return (
    <div className='flex flex-col gap-y-1'>
      {inventories.length > 1 && <div>All</div>}
      {inventories.map((warehouseInventory) => {
        const label = formatWarehouseLabel(warehouseInventory.warehouseArea!)
        return (
          <div key={warehouseInventory.warehouseId} className='whitespace-nowrap'>
            {label}
          </div>
        )
      })}
    </div>
  )
}
